export default e => setTimeout(() => {
    if (document.querySelector(e)) document.querySelector(e).value = ''
}, 50);